<template>
  <div>
    <ais-refinement-list
      v-for="facet in facets"
      :key="facet"
      :attribute="facet"
      :sort-by="['count:desc']"
      :class-names="{
        'ais-RefinementList': (facet === 'company.name' || facet === 'for_career_site')? 'hidden' : '',
        'ais-RefinementList--noRefinement': 'hidden',
      }"
    >
      <template #default="{ items, refine }">
        <ais-panel
          :class-names="{
            'ais-Panel-header': 'font-medium text-14 text-onyx mb-8px',
            'ais-Panel-body': 'mb-24px',
          }"
        >
          <template #header>
            <slot name="header" :header="facetsMap[facet]">{{
              facetsMap[facet]
            }}</slot>
          </template>
          <template #default>
            <div
              class="relative w-full justify-start"
              v-for="item in items"
              :key="getRefinementValue(facet, item)"
            >
              <vs-checkbox
                v-model="currentRefinements"
                :vs-value="getRefinementValue(facet, item)"
                @input="refine(item.value)"
                color="primary"
                icon="icon-check"
                icon-pack="feather"
                class="custom-checkbox flex items-center h-42px justify-start text-onyx-lightest text-14 mx-0"
              >
                {{ item.value }}
              </vs-checkbox>
            </div>
          </template>
        </ais-panel>
      </template>
    </ais-refinement-list>
  </div>
</template>

<script>
import { getFacets, slugify } from '../utils';

export default {
  name: 'RefinementList',
  data() {

    return {
      currentRefinements: [],
      facets: getFacets(JSON.parse(this.paramProp)),
      facetsMap: JSON.parse(this.paramProp)['facetsMap'],
    };
  },
  props: {
    paramProp: {
      default: undefined,
    },
  },
  methods: {
    getRefinementValue(facet, item) {
      const refinementValue = slugify(`${facet}_${item.value}`);
      const isValueInCurrentRefinements =
        this.currentRefinements.includes(refinementValue);

      if (item.isRefined && !isValueInCurrentRefinements) {
        this.currentRefinements.push(refinementValue);
      } else if (!item.isRefined && isValueInCurrentRefinements) {
        this.currentRefinements = [
          ...this.currentRefinements.filter(
            refinement => refinement !== refinementValue,
          ),
        ];
      }

      return refinementValue;
    },
  },
};
</script>

<style lang="scss">
.con-slot-label {
  margin-left: 3px;
  color: var(--onyx-light);
  font-size: 14px;
}
</style>
